export function initProductGallery() {
  // Powers the product-detail gallery and every order-card media carousel.
  document.querySelectorAll('[data-variant-gallery]').forEach(setupGallery);
}

function setupGallery(gallery) {
  const wrappers = [...gallery.querySelectorAll('.image-wrapper')];
  if (wrappers.length <= 1) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'gallery-wrapper';
  gallery.parentNode.insertBefore(wrapper, gallery);
  wrapper.appendChild(gallery);

  const dotsEl = document.createElement('div');
  dotsEl.className = 'gallery-dots';
  dotsEl.setAttribute('aria-hidden', 'true');

  const dots = wrappers.map((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'gallery-dot' + (i === 0 ? ' gallery-dot--active' : '');
    dot.setAttribute('aria-label', `Image ${i + 1}`);
    dot.addEventListener('click', () => {
      gallery.scrollTo({ left: i * gallery.offsetWidth, behavior: 'smooth' });
    });
    dotsEl.appendChild(dot);
    return dot;
  });

  wrapper.appendChild(dotsEl);

  function updateDots() {
    const idx = Math.round(gallery.scrollLeft / gallery.offsetWidth);
    dots.forEach((d, i) => d.classList.toggle('gallery-dot--active', i === idx));
  }

  gallery.addEventListener('scroll', updateDots, { passive: true });
}
